import { BaseTranslateService } from '../../base-translate.service';
import { TranslateRequestDto } from '../dto/request/translate-request.dto';

class TranslateService extends BaseTranslateService {
  public async translate(request: TranslateRequestDto): Promise<any[]> {
    const response = await this.post<any[]>('/translate', request);
    return response.data;
  }

  public async translateObject<T>(
    obj: T,
    from: string,
    to: string[]
  ): Promise<T> {
    const request: TranslateRequestDto = {
      from,
      to,
      inputObject: JSON.stringify(obj),
    };
    const response = await this.translate(request);
    return response[0] as T;
  }
}

const translateService = new TranslateService();
export default translateService;
